/*
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-03-26, 13:22:20
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-03-26, 16:17:01
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'PagePaginationByLimitAndOffset',

  props: {
    limit: {
      type: Number,
      default: 10,
    },
    offset: {
      type: Number,
      default: 0,
    },
    count: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    numberOfPages: {
      handler: 'getTotalNumberOfPages',
      immediate: true,
    },
    actualPage: {
      handler: 'getCurrentPage',
      immediate: true,
    },
  },
  computed: {
    numberOfPages() {
      const __modulo = (this.count / this.limit) % 1;
      return __modulo === 0 ? (this.count / this.limit) : parseInt((this.count / this.limit) + 1, 0);
    },
    actualPage() {
      return this.count !== 0 ? (this.offset / this.limit) + 1 : 1;
    },
  },
  mounted() {
    this.getTotalNumberOfPages();
    this.getCurrentPage();
  },
  methods: {
    getTotalNumberOfPages() {
      this.$emit('pagesTotal', this.numberOfPages);
    },
    getCurrentPage() {
      this.$emit('currentPage', this.actualPage);
    },
    handleNextPage() {
      this.$emit('nextPage', this.limit + this.offset);
    },
    handlePrevPage() {
      this.$emit('prevPage', this.offset - this.limit);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Common/PagePaginationByLimitAndOffset/component.js